import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAccount: {
    id: null,
    email: null,
  },
  currentStep: 0,
  formStep: "update_account",
  mainApiKey: null,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    saveSelectedAccount: (state, { payload }) => {
      state.selectedAccount = payload;
    },
    saveCurStep: (state, { payload }) => {
      state.currentStep = payload;
    },
    saveFormStep: (state, { payload }) => {
      state.formStep = payload;
    },
    saveMainApiKey: (state, { payload }) => {
      state.mainApiKey = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { saveSelectedAccount, saveCurStep, saveFormStep, saveMainApiKey } =
  commonSlice.actions;
export default commonSlice.reducer;
